import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="bg-navy py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-165" data-mp="30hzhn1ayjuld">
      <div className="mx-auto max-w-4xl px-4" data-id="element-166" data-mp="2vpg4u6k3h3hm">
        <div className="text-center" data-id="element-167" data-mp="2voek1ada12mp">
          <SectionHeading id="problem-title" data-id="element-168" data-mp="39hcpxqncid4i">Does This Sound Familiar?</SectionHeading>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-steel" data-id="element-169" data-mp="35gkgoxeh4888">
            You're working with mechanical systems and industrial machinery but struggle with gaps in technical
            understanding. When colleagues ask about material properties, mechanical design calculations, equipment
            reliability, thermodynamic principles, or manufacturing processes, you can't confidently explain the technical
            reasons.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-2xl border border-electric/40 bg-industrial p-6 shadow-glow sm:p-8" data-id="element-170" data-mp="jd3nyp3uidry">
          <p className="mb-5 inline-flex items-center gap-2 font-display text-2xl font-bold uppercase text-silver" data-id="element-171" data-mp="x5jrrs4kmftx">
            <AlertTriangleIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-172" data-mp="12335mqxcwqlc" />
            The real cost:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-173" data-mp="174shu9wbfab0">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-steel" data-id="element-174" data-mp="1c2alplvh6zc5">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-electric shadow-glow" aria-hidden="true" data-id="element-175" data-mp="1g22xs8k2vnm9" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-176" data-mp="3hvinn38ccyg6">
          <p className="mx-auto max-w-2xl text-lg font-bold text-silver" data-id="element-177" data-mp="3hwk9m2qwb5co">
            Stop wasting personal time. You're already experienced. What you need is the right tool.
          </p>
          <p className="mt-3 font-display text-3xl font-extrabold uppercase tracking-tight text-silver sm:text-4xl" data-id="element-178" data-mp="k3aanjibnllm">
            Build your entire <span className="text-gold" data-id="element-179" data-mp="tyu3fx1la465">mechanical engineering knowledge</span> today.
          </p>
        </div>
      </div>
    </section>;
}